/*
 * Mobil: filter-chippene aabner temaets eksisterende filter-drawer.
 *
 * Paa desktop folder hver chip sin egen dropdown ud. Det kan den ikke paa
 * mobil: chip-raekken kan scrolles sidelaens, og en scroll-container klipper
 * BEGGE akser, saa panelet ville blive skaaret af. CSS'en skjuler derfor
 * dropdownen under 750px, og et tryk sender kunden ind i drawer'en i stedet,
 * aabnet paa netop den gruppe der blev trykket paa.
 *
 * Koblingen mellem de to er data-index: desktop-gruppen har "3", den samme
 * gruppe i drawer'en har "mobile-3" (snippets/facets.liquid).
 */
(function () {
  const MOBIL = '(max-width: 749px)';

  document.addEventListener('click', function (event) {
    if (!window.matchMedia(MOBIL).matches) return;

    const summary = event.target.closest('.webshop-collection__filters #FacetFiltersForm .facets__summary');
    if (!summary) return;

    // Uden dette aabner <details> sin egen skjulte dropdown.
    event.preventDefault();

    const drawerSummary = document.querySelector(
      '.webshop-collection__filters .mobile-facets__wrapper .mobile-facets__open-wrapper'
    );
    if (!drawerSummary) return;

    const index = summary.closest('.js-filter') && summary.closest('.js-filter').dataset.index;

    function aabnGruppe() {
      if (!index) return;
      const gruppe = document.querySelector('#FacetFiltersFormMobile .js-filter[data-index="mobile-' + index + '"]');
      if (!gruppe || gruppe.hasAttribute('open')) return;
      const gruppeSummary = gruppe.querySelector('summary');
      // .click() og ikke open-attributten: drawer'ens undermenu glider ind via
      // klassen menu-opening, som temaets egen handler paa summary saetter.
      // Saettes open direkte, staar panelet aabent uden at vaere synligt.
      if (gruppeSummary) gruppeSummary.click();
    }

    const drawer = drawerSummary.closest('details');
    if (drawer && !drawer.hasAttribute('open')) {
      drawerSummary.click();
      // Drawer'en binder sine egne klik-handlere naar den aabner.
      setTimeout(aabnGruppe, 100);
    } else {
      aabnGruppe();
    }
  });
})();
